<template>
  <div id="owner_notifications_list" class="white">
    <div class="pa-5">
      <NotificationItem
        v-for="(notification, index) in notifications"
        :key="index"
        :notification="notification"
      >
      </NotificationItem>
      <v-btn
        class="hgt-40 round-4 white--text"
        tile
        filled
        ripple
        color="primary"
        :disabled="is_loading"
        v-if="loaded_count < total_count"
        @click="load_more_notifications"
      >
        ... Load More Notifications
      </v-btn>
    </div>
  </div>
</template>

<script>
import ServerClient from "./../../../lib/ServerClient";
import NotificationItem from "./../../../components/NotificationItem";
export default {
  name: "OwnerNotificationsList",
  components: {
    NotificationItem,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      notifications: [],
      page: 1,
      _user: null,
      loaded_count: 0,
      total_count: 0,
    };
  },
  methods: {
    update_status(to_be_updated) {
      if (to_be_updated.length > 0) {
        var vm = this;
        setTimeout(() => {
          for (var index = 0; index < to_be_updated.length; index++) {
            var to_be_updated_item = to_be_updated[index];
            ServerClient.Notifications.update_status(
              {
                ...to_be_updated_item,
              },
              (res) => {
                console.log("Success updating notification ", res);
                var rank = parseInt(res.query.rank);
                vm.notifications[rank].is_read = 1;
              },
              (errors) => {
                console.log(
                  "Errors while updating notification ",
                  to_be_updated_item
                );
              }
            );
          }
        }, 2000);
      }
    },
    load_more_notifications(){
      this.page = this.page + 1;
      this.load_items();
    },
    load_items() {
      this.$emit("on-hide-loader");
      ServerClient.Notifications.get_notifications(
        {
          user_id: this._user.id,
          page_size: 5,
          page: this.page,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //preprocess
          var loaded = this.notifications;
          var new_list = [];
          var to_be_updated = [];
          var loaded_count = this.loaded_count;
          for (var index = 0; index < res.length; index++) {
            var notification = res[index];
            notification.rank = (loaded_count + 1 ) + "/" + this.total_count;
            new_list.push(notification);
            if (parseInt(notification.is_read) == 0) {
              to_be_updated.push({
                id: notification.id,
                index: index,
                rank: loaded_count,
              });
            }
            loaded_count = loaded_count + 1;
          }
          new_list = loaded.concat(new_list);
          this.notifications = new_list;
          this.loaded_count = loaded_count;

          this.update_status(to_be_updated);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading notifications on owners notifications list",
            errors
          );
        }
      );
    },
    load_count() {
      this.$emit("on-hide-loader");
      ServerClient.Notifications.get_notifications_count(
        {
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.total_count = parseInt(res);
          this.load_items();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading notifications count on owners notifications list",
            errors
          );
        }
      );
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    //validate that user is logged in
    this.$emit("set-page-attributes", {
      title: "My Notifications",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Notifications",
          disabled: false,
          href: "/owner/notifications",
        },
        {
          text: "List",
          disabled: true,
          href: "/owner/notifications/list",
        },
      ],
    });
    this.load_count();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_notifications_list", options);
  },
};
</script>